import { useState, useEffect } from 'react';

const STORAGE_KEY = 'whatnot_prefs';

const DEFAULTS = {
    category:        'Sports Cards',
    subCategory:     'Baseball Singles',
    shippingProfile: '1-3 oz',
};

function loadPrefs() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? { ...DEFAULTS, ...JSON.parse(raw) } : { ...DEFAULTS };
    } catch {
        return { ...DEFAULTS };
    }
}

function savePrefs(prefs) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
    } catch {}
}

/**
 * Persisted Whatnot export defaults (category, subCategory, shippingProfile).
 * Reads from localStorage on mount; writes on every change.
 * All pages that create whatnot items should read from this hook or getWhatnotPrefs().
 */
export function useWhatnotPrefs() {
    const [prefs, setPrefs] = useState(loadPrefs);

    useEffect(() => {
        savePrefs(prefs);
    }, [prefs]);

    const setCategory        = (v) => setPrefs((p) => ({ ...p, category: v }));
    const setSubCategory     = (v) => setPrefs((p) => ({ ...p, subCategory: v }));
    const setShippingProfile = (v) => setPrefs((p) => ({ ...p, shippingProfile: v }));

    return { ...prefs, setCategory, setSubCategory, setShippingProfile };
}

/** Read-once helper for non-hook contexts (e.g. checklist add). */
export function getWhatnotPrefs() {
    return loadPrefs();
}
